import * as actions from 'actions';
import byIdMaker from 'reducersMakers/byIdMaker';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.CHAT_QUESTIONNAIRES_RECEIVED
  ],
  updateSuccessTypes: [
    actions.CHAT_QUESTION_UPDATE
  ],
  entityType: 'chatQuestions',
  updateKey: 'chatQuestionId'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/chatQuestions/byId/reducer.js
 **/